module.exports = __webpack_public_path__ + "img/IMG_0459_L_BlackMatted_MockedUp.6783aef1.jpg";